import * as React from "react";
import { DeepMap, FieldError, UseFormRegister } from "react-hook-form";
import { IFormValues } from "src/components/CreateGame/CreateGame";
import { Spectator } from "src/components/CreateGame/CreateGame.components";
import TextInput from "src/components/shared/Inputs/TextInput";
import Switch from "src/components/shared/Switch";

interface Props {
  register: UseFormRegister<IFormValues>;
  errors: DeepMap<IFormValues, FieldError>;
}

const SecondStep: React.FunctionComponent<Props> = ({ register, errors }) => {
  return (
    <>
      <TextInput
        label="Your display name"
        aria="Your display name"
        register={register("userName", {
          required: { value: true, message: "Required" },
          maxLength: { value: 24, message: "Name too long" },
        })}
        errorMessage={errors.userName?.message}
      />
      <Spectator>
        Join as spectator <Switch register={register("isSpectator")} />
      </Spectator>
    </>
  );
};

export default SecondStep;
